import { Component, OnInit, Input, OnDestroy, ViewChild, EventEmitter, Output } from '@angular/core';
import { Subscription, of, BehaviorSubject } from "rxjs";
import { catchError } from "rxjs/operators";
import { StratigraphicWellBondingRequirement } from "../../../common/models/well.model";
import { AuthService } from "../../../services/auth.service";
import { LunaClaimValues } from "../../../models/user-identity.model";
import { ContactService } from "../../../admin/services/contacts.service";
import { ContactStub } from "../../../admin/models/contact.model";
import { StratigraphicBondingEditorComponent } from "./stratigraphic-bonding-editor/stratigraphic-bonding-editor.component";

@Component({
    selector: 'stratigraphic-well-bonding',
    templateUrl: './stratigraphic-well-bonding.component.html',
    styleUrls: ['./stratigraphic-well-bonding.component.scss'],
    standalone: false
})
export class StratigraphicWellBondingComponent implements OnInit, OnDestroy {

    @ViewChild(StratigraphicBondingEditorComponent) _editor: StratigraphicBondingEditorComponent;

    private _contacts: ContactStub[] = [];
    private _contactsLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    private _history: StratigraphicWellBondingRequirement[] = [];

    @Input() activeBondingRequirement: StratigraphicWellBondingRequirement;
    @Input() api: string;


    get bondingRequirementHistory(): StratigraphicWellBondingRequirement[] {
        return this._history
    }

    @Output() bondingUpdated: EventEmitter<StratigraphicWellBondingRequirement> = new EventEmitter<StratigraphicWellBondingRequirement>();

    @Input() set bondingRequirementHistory(value: StratigraphicWellBondingRequirement[]) {
        if (value != null) this._history = value.sort((a, b) => {
            if (a.effectiveFrom < b.effectiveFrom) return 1;
            if (a.effectiveFrom > b.effectiveFrom) return -1;
            return 0;
        });
        else this._history = [];
    }

    get canEditBonding(): boolean {
        return this.auth.hasSystemPermission(LunaClaimValues.CanUpdateStratigraphicWellBondingRequirements) != null;
    }

    get loadingContacts(): boolean { return this._contactsLoading.value; }

    get showActiveBonding(): boolean {
        return this.activeBondingRequirement != null && (this.auth.User.isInternal || this.activeBondingRequirement.amountRequired > 0);
    }

    get showBondingHistory(): boolean {
        return this.auth.User.isInternal === true && this.bondingRequirementHistory != null && this.bondingRequirementHistory.length > 0
    }

    subscription: Subscription = new Subscription();

    constructor(public auth: AuthService, private _contactSvc: ContactService) {
      
    }

    ngOnInit() {
        if (this.auth.User.isInternal) {
            let contactSubs$ = this._contactSvc.getContactsByOrganization(this.auth.User.organizationId).pipe(
                catchError((error) => {
                    console.error(error);
                    return of([]);
                })
            ).subscribe(
                (contacts: ContactStub[]) => {
                    this._contacts = contacts;
                    this._contactsLoading.next(false);
                },
                (error) => {
                    console.error(error);
                    this._contactsLoading.next(false);
                });
            this.subscription.add(contactSubs$);
        } else {
            this._contactsLoading.next(false);
        }

    }

    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    deletePending(toDelete: StratigraphicWellBondingRequirement): void {
        toDelete.isDeleted = true;
        this.bondingUpdated.emit(toDelete);
    }

    getContactName(id: string): string {
        if (this._contacts == null) return id;
        const match = this._contacts.find(c => c.id == id);
        if (match == null) return id;
        return match.displayName;
    }

    onBondingUpdated(req: StratigraphicWellBondingRequirement): void {
        req.enteredBy = this.auth.User.id;
        req.enteredOn = new Date();
        this.bondingUpdated.emit(req);
    }

    openEditor(api: string): void {
        this._editor.openDialog(api);
    }
}
